import { Col, Row } from "reactstrap";
import Card from "../ui-components/card";
import { ComponentSpinner } from "../spinner";
import Flex from "../ui-components/flex";
import Highcharts from "highcharts";
import HighchartsHeatmap from "highcharts/modules/heatmap";
import HighchartsReact from "highcharts-react-official";
import { NoDataComponent } from "../no-data-component";
import dayjs from "dayjs";
import size from "lodash/size";
import { t } from "i18next";

// Initialize the heatmap module
HighchartsHeatmap(Highcharts);

export default function HeatMap (propsIn) {
    const {
        id,
        data,
        title = null,
        cardHeader = {},
        statsView,
        subtitle = "",
        loading = false,
        actionItems
    } = propsIn;

    const options = {
        chart: {
            type           : "heatmap",
            plotBorderWidth: 0,
            height         : 300,
            marginTop      : 100
        },

        title: {
            text : title || "",
            align: "left"
        },
        subtitle: {
            text : subtitle,
            align: "left"
        },

        xAxis: {
            type              : "category",
            title             : {},
            lineWidth         : 0,
            gridLineWidth     : 0,
            minorGridLineWidth: 0,
            tickWidth         : 0,
            opposite          : true,
            labels            : {
                enabled: false
            }
        },
        yAxis: {
            type              : "category",
            categories        : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            title             : {},
            reversed          : true,
            lineWidth         : 0,
            gridLineWidth     : 0,
            minorGridLineWidth: 0,
            minTickInterval   : 1,
            labels            : {
                style: {
                    fontSize: "9px"
                }
            }
        },
        exporting: {
            buttons: {
                contextButton: {
                    enabled: false // Disable the hamburger menu
                }
            },
            filename    : cardHeader?.title || "heatmap",
            scale       : 1,
            sourceWidth : 1100,
            sourceHeight: 400
        },
        colorAxis: {
            min              : 0,
            max              : 10,
            tickInterval     : 1,
            tickmarkPlacement: "on",
            stops            : [
                [0, "#eeeeee"],
                [0.1, "#eeeeee"],
                [0.2, "#77ACF1"],
                [0.3, "#3282B8"],
                [0.4, "#0F4C75"]
            ],
            labels: {
                enabled: false
            }
        },

        legend: {
            enabled      : true,
            verticalAlign: "bottom",
            layout       : "horizontal",
            margin       : 30,
            y            : 40
        },
        credits: {
            enabled: false
        },
        tooltip: {
            useHTML: true,
            formatter () {
                const datePoint = this.point;
                const s = dayjs(datePoint.date).format("MMM D, YYYY");
                return s;
            }
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled : true,
                    y       : 20,
                    crop    : false,
                    overflow: "allow",
                    formatter () {
                        if (this.point.y === 6 || this.point.y === 16) return this.point.week;
                        else return null;
                    },
                    style: {
                        fontSize   : "9px",
                        color      : "#999999",
                        fontWeight : "normal",
                        textOutline: "none"
                    }
                },
                borderColor: "#ffffff",
                borderWidth: 3
            }
        },
        series: data
    };

    const ChartView = () => {
        return loading ? (
            <ComponentSpinner height="300px" />
        ) : size(data) ? (
            <HighchartsReact
                highcharts={Highcharts}
                options={options} />
        ) : (
            <NoDataComponent title="No Data" />
        );
    };

    return (
        <Card children={<div>
            <Flex justify="between" align="start" className="w-100 mb-2">
                <Flex column className={!actionItems ? "w-100 " : ""}>
                    {cardHeader.title ? (
                        <span className="card-title" data-cy="title-header">
                            {t(cardHeader.title)}
                        </span>
                    ) : null}
                    {cardHeader.desc ? (
                        <p className="text-muted" data-cy="desc-header">
                            {t(cardHeader.desc)}
                        </p>
                    ) : null}
                    {cardHeader.customTitle || <></>}
                </Flex>
                {!loading ? (
                    <Flex
                        className="h-100 column-gap-25 row-gap-25 w-sm-40"
                        justify="center"
                        align="center"
                        data-cy="action-items">
                        {actionItems}
                    </Flex>
                ) : null}
            </Flex>
            <Row>
                <Col lg={statsView ? 9 : 12}>
                    <ChartView />
                </Col>
                {statsView ? (
                    <Col lg={3} className="border-start">
                        {statsView}
                    </Col>
                ) : null}
            </Row>
        </div>} data-cy={id} />

    );
}
